export default __webpack_public_path__ + "static/media/PatrickMasbourian.b4a78364.png";